<template>
  <div class="h-screen flex flex-col">
    <NuxtLoadingIndicator/>
<!--    <AppHeader />-->
    <div class="flex flex-1 overflow-auto">
      <AppLeftMenu @on-expand="onDrawerExpand"/>
      <div v-bind:class="pageAreaClass()">
        <div class="flex items-center pr-[15px] page-app-background">
          <Breadcrumbs class="breadcrumbs-panel"/>
          <div class="flex gap-3 items-center">
            <UButton
              class="cursor-pointer"
              :label="taskLabel"
              to="/workspace/inbox"/>
            <div v-if="isShowCorrectionControl">
              <UButton
                class="w-[160px] justify-center flex"
                @click="correctVisible=!correctVisible"
                :label="correctionLabel"/>
              <CorrectionSelectControl v-if="correctVisible"
                @on-close="correctVisible=false"/>
            </div>
          </div>
        </div>
        <div class="flex flex-1 overflow-auto" >
          <slot/>
        </div>
      </div>
    </div>
    <UNotifications />
  </div>
</template>

<style scoped>

</style>
<script setup lang="ts">
import {AppLeftMenu} from "#components";
import {ACTIVE_TASK_STATE, CORRECTION_ON_DATE_STATE, SELECTED_CORRECTIONS_STATE} from "~/states/state";
import {CORRECTION_ON_DATE_API} from "~/routes/ari_routes";
import type {ICorrect} from "~/types/corrects";
import type {ITask, JsonDataResponse} from "~/types/types";
/*
import type {HookKeys} from "hookable";
import type {RuntimeNuxtHooks} from "#app";
*/

const correctVisible = ref(false)
const expanded = ref(localStorage.getItem("menuExpanded") == 'true')
const selectedCorrections = useState<number[]>(SELECTED_CORRECTIONS_STATE, ()=>[])
const corrections = useState<ICorrect[]>(CORRECTION_ON_DATE_STATE, ()=> [])
const {options} = useFetchHelper()
const {htmlDate} = useHelpers()
const route = useRoute()
const isShowCorrectionControl = computed(()=>route.meta.showCorrectionControl !== undefined ? route.meta.showCorrectionControl : true)
const activeTask = useState<[]>(ACTIVE_TASK_STATE, ()=>[])
const toast = useToast()

const onDrawerExpand = (value: boolean) => {
  expanded.value  = value
}

const pageAreaClass = () => {
  let res = 'flex flex-col w-[calc(100%-var(--drawer-width))]'

  if (!expanded.value)
    res = 'flex flex-col w-[calc(100%-var(--drawer-panel))]'

  return res
}

// const nuxtApp = useNuxtApp()
//
// const testHook = 'app:user:registered' as HookKeys<RuntimeNuxtHooks>
//
// nuxtApp.hook(testHook, (payload: any): void => {
//   console.log('A new user has registered!', payload)
// })
//
// nuxtApp.hook(testHook as HookKeys<RuntimeNuxtHooks>, (payload: any): void => {
//   console.log('A new user has registered2!', payload)
// })
//
// const callHook = async() => {
//   await nuxtApp.callHook(testHook as HookKeys<RuntimeNuxtHooks>, {
//     id: 1,
//     name: 'John Doe',
//   })
// }

const correctionLabel = computed(()=>
  "Корректировки"  + (selectedCorrections.value.length > 0 ? ` (${selectedCorrections.value.length})` : '')
)

const taskLabel = computed(()=> {
  return 'Задачи' + (activeTask.value.length > 0 ? ` (${activeTask.value.length})` : '')
})

const {data} = await useFetch<JsonDataResponse<ICorrect[]>>(CORRECTION_ON_DATE_API + htmlDate(new Date()), options())

if (data.value?.data)
  corrections.value = data.value?.data

const hasOverdueTasks = computed(() => {
  return activeTask.value.some((task: ITask) => {
    if (!task.deadline) {
      return false
    }

    return new Date(task.deadline) < new Date()
  })
})

const showOverdueTasksWarning = () => {
  if (hasOverdueTasks.value) {
    toast.add({
      id: 'overdue-tasks',
      title: 'Есть просроченные задачи',
      description: 'Проверьте список задач и обновите сроки выполнения.',
      color: 'red',
      icon: 'i-heroicons-exclamation-triangle',
      timeout: 8000,
    })
  }
}

watch(route, _ => {
  showOverdueTasksWarning()
})

onMounted(()=>{
  showOverdueTasksWarning()
})
</script>
